import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const warningTypeLocaleModule: LocaleModule = {
  name: "warningType",
  messages: { en: en, it: it },
};
